import React from 'react';
import { Button } from '@mui/material';
import _ from 'lodash';

export interface BakeasyButtonProps {
  label?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  variant?: any;
  style?: React.CSSProperties;
  startIcon?: any;
  endIcon?: any;
  size?: any;
  type?: any;
  color?: any;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export function BakeasyButton(props: BakeasyButtonProps) {
  return (
    <Button
      startIcon={props?.startIcon ? props?.startIcon : null}
      endIcon={props?.endIcon ? props?.endIcon : null}
      variant={props?.variant ? props?.variant : 'contained'}
      disabled={props?.disabled ? props?.disabled : false}
      fullWidth={props?.fullWidth ? props?.fullWidth : false}
      size={props?.size ? props?.size : 'medium'}
      color={props?.color}
      className={props.className || ''}
      sx={{
        marginX: 0.5,
        borderRadius: 2,
        paddingY: 1,
        color: props?.variant === 'outlined' ? 'primary' : 'white',
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
      style={props?.style !== undefined ? props?.style : { textTransform: 'initial' }}
      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        props.onClick(event);
      }}
    >
      {props.label}
    </Button>
  );
}
